import React, { forwardRef } from "react";
import { useMask } from "@react-input/mask";
import { useTemplateStore } from "@/zustand/templateStore.js";
import s from "@/components/Inputs/Input.module.scss";
import cn from "@/utils/classNames.js";

const Expiration = forwardRef(
  (
    { placeholder, error, name, type, width, value, margin, handleChange, icon, max, comment, trigger, dataTestId },
    ref
  ) => {
    const inputRef = useMask({ mask: "__/__", replacement: { _: /\d/ } });
    const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

    return (
      <div
        className={s.inputContainer}
        style={{
          width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
          marginRight: margin ? "12px" : "0px",
          backgroundColor: "transparent",
        }}
        ref={ref}
      >
        <div
          className={cn(
            s.input,
            s.input__text,
            error && s.input__error,
            isEnhancedContrast && s.enhancedContrast,
            isEnhancedContrast && error && s.enhancedContrast__error
          )}
        >
          <input
            ref={inputRef}
            data-testid={dataTestId}
            maxLength={max}
            className={s.styledInput}
            type={type}
            name={name}
            autoComplete="cc-exp"
            value={value}
            onBlur={() => {
              trigger(["card_exp_year", "card_exp_month"]);
            }}
            onChange={handleChange}
          />
          <label
            className={cn(
              s.styledLabel,
              value?.length > 0 && s.styledLabel__active,
              isEnhancedContrast && s.styledLabel__enhancedContrast
            )}
          >
            {placeholder}
          </label>
          {icon && (
            <div
              className={s.input__img}
              style={{
                backgroundImage: `url(${icon}`,
              }}
            >
              {comment && <span className={s.input__comment}>{comment}</span>}
            </div>
          )}
        </div>
        {error && <span className={s.formError}>{error}</span>}
      </div>
    );
  }
);

export default Expiration;
